import {
  CONFIRM_ACTION_ASK_CONFIRM_ACTION,
  CONFIRM_ACTION_CANCEL_ACTION,
  CONFIRM_ACTION_CONFIRM_ACTION,
  CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL,
  CONFIRM_ACTION_SET_NEXT_ACTION,
  CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL
} from './constants'

/****************************************************************************************************
 * Action Confirmation
 ****************************************************************************************************/

export function showConfirmActionModal () {
  return {type: CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL, payload: {}}
}

export function hideConfirmActionModal () {
  return {type: CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL, payload: {}}
}

export function confirmAction (nextAction) {
  return {type: CONFIRM_ACTION_CONFIRM_ACTION, payload: {nextAction}}
}

export function askConfirmAction (nextAction) {
  return {type: CONFIRM_ACTION_ASK_CONFIRM_ACTION, payload: {nextAction}}
}

export function cancelAction () {
  return {type: CONFIRM_ACTION_CANCEL_ACTION, payload: {}}
}

export function setNextAction (nextAction) {
  return {type: CONFIRM_ACTION_SET_NEXT_ACTION, payload: {nextAction}}
}

/****************************************************************************************************
 * End Action Confirmation
 ****************************************************************************************************/



// WEBPACK FOOTER //
// ./app/actions/confirm-action/index.js